import { capitalize } from "@patternfly/react-core";

/**
 * Converts error messages to human-readable clear messages
 * @param errorMessage
 */
export function transposeErrorMessages(errorMessage: string) {
	if (typeof errorMessage !== "string") return errorMessage;

	// Define the mappings from field names to their user-friendly names
	const mappings: Record<string, string> = {
		"helm_chart.chart_name": "helm chart name",
		label: "helm chart name",
		name: "component name",
	};

	let isSingleField = true;

	// Error Pattern: "Fields ['field1', 'field2'] do not meet Red Hat naming criteria. It cannot start with 'Red Hat' or any variant."
	errorMessage = errorMessage.replace(/\[([^\]]+)\]/g, (_, insideBrackets: string) => {
		// Split the content inside the brackets by commas and trim spaces
		const fields = insideBrackets?.split(",").map((field) => field?.trim()?.replace(/^['"]|['"]$/g, ""));

		// Replace each field with its corresponding human-readable name if a mapping exists
		const replacedFields = fields.map((field) => {
			// If there's a mapping, replace it with the mapped value, otherwise leave it as is
			return mappings[field] || field;
		});

		// Join the replaced fields with commas and 'and' before the last element
		if (replacedFields.length > 1) {
			isSingleField = false;
			return `${replacedFields.slice(0, -1).join(", ")} and ${replacedFields[replacedFields.length - 1]}`;
		}
		// If there's only one field, just return it
		return replacedFields.join("");
	});

	// Error Pattern: "field must not be <value>" error messages
	errorMessage = errorMessage.replace(/(\S+)\s+must\s+not\s+be\s+(.*)/i, (_, fieldName, restOfMessage) => {
		// Replace field name with the human-readable name
		const userFriendlyFieldName = mappings[fieldName] || fieldName;

		// Return the updated message with the human-readable field name and merged rest of message
		return `${userFriendlyFieldName} must not be ${restOfMessage}`;
	});

	// Singular and rural fix
	if (isSingleField) {
		errorMessage = errorMessage.replace(/Fields/g, "Field");
		errorMessage = errorMessage.replace(/fields/g, "field");
	}
	return capitalize(errorMessage);
}
